import { DropzoneProtected } from '@components'

import { Attachment, Button, Space, Text } from '@billy/design-system'
import { FileRejection } from 'react-dropzone'
import { useTranslation } from 'react-i18next'

import { ChooseFileDropdown } from '@features/attachments/elements/ChooseFileDropdown'

import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { DrawerSection } from '../DrawerSection'

interface AddAttachmentSectionProps {
  isLoading?: boolean
  onAttachmentSelect: (attachment: Attachment) => void
  onFilesDropped: (filesAccepted: File[], filesRejected?: FileRejection[]) => void
  scope: Scope
  trackingContext: TrackingContext
}

export const AddAttachmentSection = ({
  isLoading,
  onAttachmentSelect,
  onFilesDropped,
  scope,
  trackingContext,
}: AddAttachmentSectionProps) => {
  const { t } = useTranslation()

  const triggerButton = (
    <>
      <Space />
      <ChooseFileDropdown
        onFileFromDeviceSelect={onFilesDropped}
        onFileFromUploadsSelect={onAttachmentSelect}
        trigger={
          <Button icon="plus" variant="outlined" loading={isLoading} iconRight="chevronDown">
            {t('ledger.attachments.drawer')}
          </Button>
        }
      />
    </>
  )

  return (
    <DrawerSection title={t('ledger.attachments')}>
      <DropzoneProtected
        customTrigger={triggerButton}
        isUploading={isLoading}
        onDrop={onFilesDropped}
        scopes={[scope]}
        trackingContext={trackingContext}
      />
      <Text variant="bodySM">{t('ledger.attachments.formats')}</Text>
    </DrawerSection>
  )
}
